module.exports = "//static.hsappstatic.net/connect-dot-com-public-ui/static-1.1590/images/connect-logo-bg-homepage-header.svg"